<template>
  <div class="space-y-8">



    <section v-for="(category, index) in resultado_variables" :key="index">
      <v-row>
        <v-col cols="8">

          <h2 class="text-xl font-bold mb-4">{{  this.columnas[category.title]  }}</h2>
<!-- this.columnas[category.title] -->
         <table class="min-w-full border border-gray-300 table-fixed">
          <colgroup>
            <col style="width: 50%;">
            <col style="width: 25%;">
            <col style="width: 25%;">
          </colgroup>

<thead>
    <tr>
      <th class="border px-4 py-2 text-left">{{this.$t('simulacion.modulo.resultado.codigo_colores')}}</th>
      <th class="border px-4 py-2 text-left" colspan="2">
        <span class="px-2 py-1 inline-block" style="background-color: azure;">Input</span>
        <span class="px-2 py-1 inline-block ml-2" style="background-color: #B3E5FC;">Output</span>
      </th>
    </tr>
    <tr>
      <th class="border px-4 py-2">{{this.$t('simulacion.modulo.resultado.variable')}}</th>
      <th class="border px-4 py-2">{{this.$t('simulacion.modulo.resultado.valor')}}</th>
      <th class="border px-4 py-2">{{this.$t('simulacion.modulo.resultado.unidad')}}</th>
    </tr>
  </thead>


          <!--
          <thead class="bg-gray-200">
            <tr>
              <th class="border px-4 py-2">Variable</th>
              <th class="border px-4 py-2">Valor</th>
              <th class="border px-4 py-2">Unidades</th>
            </tr>
          </thead>
          -->
          <tbody>
            <!--
            <tr v-for="(item, idx) in category.data" :key="idx">
              <td class="border px-4 py-2 font-semibold truncate">
                {{ $t('simulacion.modulo.resultado.resumen.' + item.variable) }}
              </td>
              <td class="border px-4 py-2 truncate">{{ typeof item.value === 'number' ? item.value.toFixed(2) : item.value }}</td>
              <td class="border px-4 py-2 truncate">{{ item.unit || '-' }}</td>
            </tr>
            -->
            <tr 
              v-for="(item, idx) in category.data" :key="idx" 
              :style="{
                  backgroundColor: item.origen === 'input' ? 'azure' : item.origen === 'output' ? '#B3E5FC' : 'transparent'
                }"
                            
            >
            
              <td class="border px-4 py-2 font-semibold truncate">
                {{ $t('simulacion.modulo.resultado.resumen.' + item.variable) }}
              </td>
              <td class="border px-4 py-2 truncate">{{ typeof item.value === 'number' ? item.value.toFixed(2) : item.value }}</td>
              <td class="border px-4 py-2 truncate">{{ item.unit || '-' }}</td>

          </tr>

          </tbody>
        </table>



        </v-col> 
        <v-col cols="4">
        </v-col>
      </v-row>

    </section>
  </div>
</template>


<script>
export default {

  props: {
    resultado_variables: {
      type: Object,
      required: true,
    },
    
  },

  data() {
      return {
        columnas: {
          'General':this.$t('simulacion.modulo.resultado.general'),
          'Energía':this.$t('simulacion.modulo.resultado.energia'),
          'Planta de electrólisis':this.$t('simulacion.modulo.resultado.planta_electrolisis'),
          'Electrolizador':this.$t('simulacion.modulo.resultado.electrolizador'),
          'Almacenamiento de hidrógeno':this.$t('simulacion.modulo.resultado.almacenamiento_hidrogeno'),
          'Baterías':this.$t('simulacion.modulo.resultado.baterias'),
          'Demanda':this.$t('simulacion.modulo.resultado.demanda'),
          'Parámetros económicos':this.$t('simulacion.modulo.resultado.param_econ'),
        },

        sections: [
          {
            title: 'General',
            data: [
              { variable: 'Intervalo de años evaluados', value: '2025 - 2100' },
              { variable: 'Total años', value: 25 },
              { variable: 'Función objetivo', value: 'Maximizar VAN' },
              { variable: 'Modo de aprovisionamiento', value: 'Compra sin límite de precio a mercado' },
              { variable: 'Opciones del electrolizador', value: 'Optimizar electrolizador' },
              { variable: 'Opciones del almacenamiento', value: 'Optimizar almacenamiento' },
              { variable: 'Opciones solar fotovoltaica', value: 'Optimizar planta solar fotovoltaica' },
              { variable: 'Opciones eólica', value: 'Optimizar planta eólica' },
              { variable: 'Opciones PPA', value: 'Optimizar PPAs' },
              { variable: 'Opciones de acceso de compra', value: 'Optimizar potencia de acceso de compra' },
              { variable: 'Opciones demanda', value: 'Demanda anual' },
              { variable: 'LCOH', value: '0', unit: 'EUR/kg/h2' },
              { variable: 'NPV', value: '0', unit: 'MEUR' }
            ]
          },
          {
            title: 'Energía',
            data: [
              { variable: 'Potencia de acceso', value: '0.00', unit: 'MW' },
              { variable: 'Energía comprada a mercado', value: '0.00', unit: 'GWh' },
              { variable: 'Potencia contratada PPA1', value: '0.00', unit: 'MW' },
              { variable: 'Energía consumida PPA1', value: '0.00', unit: 'GWh' },
              { variable: 'Potencia contratada PPA2', value: '0.00', unit: 'MW' },
              { variable: 'Energía consumida PPA2', value: '0.00', unit: 'GWh' },
              { variable: 'Potencia contratada PPA3', value: '0.00', unit: 'MW' },
              { variable: 'Energía consumida PPA3', value: '0.00', unit: 'GWh' },
              { variable: 'Potencia instalada planta solar fotovoltaica', value: '0.00', unit: 'MW' },
              { variable: 'Energía producida planta solar fotovoltaica', value: '0.00', unit: 'GWh' },
              { variable: 'Energía consumida planta solar fotovoltaica', value: '0.00', unit: 'GWh' },
              { variable: 'Vertidos planta solar fotovoltaica', value: '0.00', unit: 'TWh' },
              { variable: 'Potencia instalada planta eólica', value: '0.00', unit: 'MW' },
              { variable: 'Energía producida planta eólica', value: '0.00', unit: 'GWh' },
              { variable: 'Energía consumida planta eólica', value: '0.00', unit: 'GWh' },
              { variable: 'Vertidos planta eólica', value: '0.00', unit: 'TWh' }
            ]
          },
          {
            title: 'Planta de electrólisis',
            data: [
              { variable: 'Consumo electricidad BOP en parada', value: '0.00', unit: 'GWh' },
              { variable: 'Consumo electricidad BOP en operación', value: '0.00', unit: 'GWh' },
            ]
          },
          {
            title: 'Electrolizador',
            data: [
              { variable: 'Potencia nominal electrolizador', value: '0.00', unit: 'MW' },
              { variable: 'Potencia mínima electrolizador', value: '0.00', unit: 'MW' },
              { variable: 'Horas de funcionamiento electrolizador', value: '0.00', unit: 'h/año' },
              { variable: 'Degradación anual electrolizador', value: '0.00', unit: '%' },
              { variable: 'Sustitución stacks electrolizador', value: '0.00', unit: 'años' },
              { variable: 'Consumo de agua electrolizador', value: '0.00', unit: 'l/kg H2' },
              { variable: 'Consumo energía electrolizador', value: '0.00', unit: 'GWh' },
              { variable: 'Consumo energía BOP', value: '0.00', unit: 'GWh' }
            ]
          },
          {
            title: 'Almacenamiento de hidrógeno',
            data: [
              { variable: 'Capacidad de almacenamiento de hidrógeno', value: '0.00', unit: 'ton H2' },
              { variable: 'Pérdidas estáticas almacenamiento de hidrógeno', value: '0.00' },
              { variable: 'Pérdidas por extracción almacenamiento de hidrógeno', value: '0.00' },
              { variable: 'Pérdidas por inyección almacenamiento de hidrógeno', value: '0.00' }
            ]
          },
          {
            title: 'Baterías',
            data: [
              { variable: 'Potencia baterías', value: '0.00', unit: 'MW' },
              { variable: 'Duración baterías', value: '0.00', unit: 'h' },
              { variable: 'Capacidad de almacenamiento baterías', value: '0.00', unit: 'MWh' },
              { variable: 'Rendimiento baterías', value: '0.00', unit: '%' },
              { variable: 'Degradación anual baterías', value: '0.00', unit: '%' },
              { variable: 'Vida útil baterías', value: '0.00', unit: 'años' },
              { variable: 'Consumo energía baterías', value: '0.00', unit: 'GWh' },
              { variable: 'Producción energía baterías', value: '0.00', unit: 'GWh' }
            ]
          },
          {
            title: 'Demanda',
            data: [
              { variable: 'Demanda de H2 Verde obligatoria', value: '0.00', unit: 'ton H2' },
              { variable: 'Precio demanda H2 Verde obligatoria', value: '0.00', unit: 'EUR/ton H2' },
              { variable: 'Demanda H2 Verde opcional', value: '0.00', unit: 'ton H2' },
              { variable: 'Precio demanda H2 Verde opcional', value: '0.00', unit: 'EUR/ton H2' },
              { variable: 'Demanda de H2 LC obligatoria', value: '0.00', unit: 'ton H2' },
              { variable: 'Precio demanda H2 LC obligatoria', value: '0.00', unit: 'EUR/ton H2' },
              { variable: 'Demanda H2 Lc opcional', value: '0.00', unit: 'ton H2' },
              { variable: 'Demanda H2 no suministrada', value: '0.00', unit: 'ton H2' },
              { variable: 'Precio demanda H2 LCopcional', value: '0.00', unit: 'EUR/ton H2' },
            ]
          },
          {
            title: 'Parámetros económicos',
            data: [
              { variable: 'CAPEX BOP', value: '0.00', unit: 'MEUR'},
              { variable: 'CAPEX ducto', value: '0.00', unit: 'MEUR' },
              { variable: 'CAPEX conexión eléctrica', value: '0.00', 'unit': 'MEUR'},
              { variable: 'CAPEX tube-tráilers', value:'0.00', 'unit': 'MEUR'},
              { variable: 'CAPEX electrolizador', value: '0.00', unit: 'MEUR' },
              { variable: 'CAPEX reemplazo stacks electrolizador', value: '0.00', unit: 'MEUR' },
              { variable: 'CAPEX almacenamiento', value: '0.00', unit: 'MEUR' },
              { variable: 'CAPEX potencia de acceso', value: '0.00', unit: 'MEUR' },
              { variable: 'CAPEX baterías', value: '0.00', unit: 'MEUR' },
              { variable: 'CAPEX reemplazo stacks baterías', value: '0.00', unit: 'MEUR' },
              { variable: 'CAPEX planta solar fotovoltaica', value: '0.00', unit: 'MEUR' },
              { variable: 'CAPEX planta eólica', value: '0.00', unit: 'MEUR' },
              { variable: 'CAPEX total', value: '0.00', unit: 'MEUR' },
              { variable: 'OPEX total',value: '0.00',unit: 'MEUR'},
              { variable: 'Coste PPA1', value: '0.00', unit: 'MEUR' },
              { variable: 'Coste PPA2', value: '0.00', unit: 'MEUR' },
              { variable: 'Coste PPA3', value: '0.00', unit: 'MEUR' },
              { variable: 'Coste energía a mercado', value: '0.00', unit: 'MEUR' },
              { variable: 'Coste tarifas', value: '0.00', unit: 'MEUR' },
              { variable: 'Coste GDOs eléctricas', value: '0.00', unit: 'MEUR' },
              { variable: 'Coste agua', value: '0.00', unit: 'MEUR' },
              { variable: 'OPEX total', value: '0.00', unit: 'MEUR' },
              { variable: 'Coste total', value: '0.00', unit: 'MEUR' },
              { variable: 'Ingreso demanda obligatoria', value: '0.00', unit: 'MEUR' },
              { variable: 'Ingreso demanda opcional', value: '0.00', unit: 'MEUR' },
              { variable: 'Ingreso planta solar fotovoltaica', value: '0.00', unit: 'MEUR' },
              { variable: 'Ingreso planta eólica', value: '0.00', unit: 'MEUR' },
              { variable: 'Ingreso PPA1', value: '0.00', unit: 'MEUR' },
              { variable: 'Ingreso PPA2', value: '0.00', unit: 'MEUR' },
              { variable: 'Ingreso PPA3', value: '0.00', unit: 'MEUR' },
              { variable: 'Inflación anual', value: '0.00', unit: '%' },
              { variable: 'Tasa de descuento', value: '0.00', unit: '%' }
            ]
          }
        ]

      };
      
  },
  watch:{
        '$i18n.locale'() {
            this.columnas= {
            'General':this.$t('simulacion.modulo.resultado.general'),
          'Energía':this.$t('simulacion.modulo.resultado.energia'),
          'Planta de electrólisis':this.$t('simulacion.modulo.resultado.planta_electrolisis'),
          'Electrolizador':this.$t('simulacion.modulo.resultado.electrolizador'),
          'Almacenamiento de hidrógeno':this.$t('simulacion.modulo.resultado.almacenamiento_hidrogeno'),
          'Baterías':this.$t('simulacion.modulo.resultado.baterias'),
          'Demanda':this.$t('simulacion.modulo.resultado.demanda'),
          'Parámetros económicos':this.$t('simulacion.modulo.resultado.param_econ'),
          }
      },
  },


}
</script>

<style scoped>
table {
  border-collapse: collapse;
  width: 100%;
}
th, td {
  text-align: left;
  padding: 8px;
}


</style>
